import Card from '..';
import { Course, Enum_Bookmark_Category, Enum_Course_Type } from '@edwin-group/cj-graphql';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Button from '@/components/Button';
import { useNavigate } from 'react-router-dom';
import BookmarkButton from '@/components/Bookmark/BookmarkButton';
import { getAuthors } from '@/utils/learn';
const arrowCourseImg = '/card/arrow-course.png';
const playIcon = '/card/play-icon.png';

const CourseCard = ({
  course,
  buttonText = 'Start',
  showBookmarkIcon,
  onRemoveFromBookmark,
}: {
  buttonText?: string;
  course: Course;
  showBookmarkIcon?: boolean;
  onRemoveFromBookmark?: () => void;
}) => {
  const navigate = useNavigate();

  const CardButton = () => {
    const link = `/learn/course/${course.slug}`; // TODO

    return (
      <div className="rows-span-1 flex flex-col items-start gap-1">
        <Button
          theme="solid-primary-600"
          onClick={() => {
            if (link) {
              navigate(link);
            }
          }}>
          <img src={playIcon} className="h-auto w-[12px]" alt="play icon" />
          {buttonText}
        </Button>
      </div>
    );
  };

  return (
    <Card
      key={course?.slug}
      title={course.title || ''}
      description={course.description || ''}
      author={
        getAuthors(course as Course)
          ?.map((author) => author?.name || author?.name)
          .join(', ') || ''
      }
      arrowImg={arrowCourseImg}
      tags={
        <DefaultContentTemplateTags
          tags={[course?.type || '']}
          className="!mb-2 !mt-0"
          duration={course?.duration || undefined}
        />
      }
      image={{
        url: course.thumbnail.url || '',
        alternativeText: course.thumbnail.alternativeText || '',
      }}
      button={<CardButton />}
      bookmarkButton={
        showBookmarkIcon ? (
          <BookmarkButton
            relationId={course?.documentId || ''}
            metadata={course}
            category={
              course?.type === Enum_Course_Type.Training ? Enum_Bookmark_Category.Training : Enum_Bookmark_Category.Cpd
            }
            onRemoveFromBookmark={onRemoveFromBookmark}
          />
        ) : null
      }
    />
  );
};

export default CourseCard;
